'use client';

import { Flex, Grid, Typography } from '@coolblue-development/freddy';
import readExplanationTrigger from '@coolblue-development/ga4-events/triggers/CrossSellToggle/readExplanationTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { MiniProductPage } from '@coolblue-development/next-mini-product-page/client';
import { SalesPrice, SalesPriceCurrent } from '@coolblue-development/next-sales-price/client';
import { SummaryItem } from '@features/add-to-cart-page/components/SummaryStore';
import { useTranslation } from '@i18n/useTranslation';

import styles from './Charger.styles';
import Icon from './Icon';

export default function Charger({
  charger,
  isInMissingChargerWordingSplitTest
}: {
  charger: SummaryItem;
  isInMissingChargerWordingSplitTest: boolean;
}) {
  const { t } = useTranslation('webshop.addToCart.productSummary.crossSellCharger');
  const { trackEvent } = useAnalytics();

  const wordingKey = isInMissingChargerWordingSplitTest ? 'adapter' : 'charger';

  const { id, shortName, salesPrice } = charger;
  const chargerId = Number(id);

  const { accessorySummary, container } = styles;

  const statusId = `${wordingKey}-status-${id}`;

  return (
    <>
      <Grid templateColumns='auto 1fr' alignItems='center' columnGap='1rem' sx={container}>
        <Flex alignItems='center' gap='.6rem'>
          <Icon aria-hidden='true' />

          <Typography component='span' id={statusId} aria-live='polite'>
            {t(`${wordingKey}.added`)}
          </Typography>
        </Flex>

        <Flex
          alignItems='flex-start'
          justifyContent='space-between'
          gap='200'
          pl='2.2rem'
          sx={accessorySummary}
          role='region'
          aria-label={t('productDetails')}
        >
          {typeof id === 'number' ? (
            <MiniProductPage
              productId={id}
              onOpen={() =>
                trackEvent(
                  readExplanationTrigger({
                    subject_type: 'item',
                    subject_id: `${chargerId}`
                  })
                )
              }
            >
              {shortName}
            </MiniProductPage>
          ) : (
            <Typography color='interactiveSubtle'>{shortName}</Typography>
          )}

          <SalesPrice
            currentPrice={<SalesPriceCurrent price={salesPrice.includingVat} />}
            size='small'
          />
        </Flex>
      </Grid>
    </>
  );
}
